import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { SearchService } from '@services/search.service';
import { SocialService } from '@services/social.service';
import { ServiceService } from '@services/service.service';
import { CreateService } from '@services/create.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { ScrollToService } from 'ng2-scroll-to-el';
import { MailService } from '@services/mail.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { CommonService } from '@services/common.service';
import {
  SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { CommonPipe } from '@pipes/common.pipe';
import * as _ from 'lodash';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-bbusiness',
  templateUrl: './bbusiness.component.html',
  providers: [CommonPipe],
  styleUrls: ['./bbusiness.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class BbusinessComponent implements OnInit {

  application = "business";
  page_load = true;
  component = '';
  is_owner = false;
  rate = 0;
  reviewRate = 0;
  params: any = [];
  report_param: any = [];
  reviews: any = [];
  id = "";
  response: any = [];
  hour_start: '';
  hour_end = '';
  weekday: any = [];
  hours_start: any = [];
  rate_readonly = false;
  hours_end: any = [];
  tag:any=[];
  category:any=[];
  appEditForm: FormGroup;
  compose_response: any = [];
  reviewForm: FormGroup;
  review_count = 0;
  public config: SwiperConfigInterface = {};
  images: any = [];
  isLogin = false;
  btn_process = false;
  review_error: any = { "name": "", "description": "" };
  sidetabs={"recent":"Recent","viewed":"Views","rated":"Popular","liked":"Liked","favorites":"Favorite"};
  map_url='https://www.google.com/maps/embed/v1/place?q=';
  address="";
  latitude="";
  operation='';
  operations:any=[];
  constructor(private _commonService: CommonService,private _service: ServiceService, public ngxSmartModalService: NgxSmartModalService, private _mail: MailService, private scrollService: ScrollToService, private router: Router, private _commonPipe: CommonPipe, private _createService: CreateService, private _socialService: SocialService, private _searchService: SearchService, private fb: FormBuilder, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    this.operation='view'+_.upperFirst(this.application);
    this.operations=this._global.api_doc(this.application,'operations');

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.appEditForm = this.fb.group({
      hours: new FormArray([])
    });
    this.reviewForm = this.fb.group({
      name: [],
      description: []
    });
    this.weekday = this._global.BUSINESS_WEEKDAY;
    this.hours_start = this._global.BUSINESS_HOURS_START;
    this.hours_end = this._global.BUSINESS_HOURS_END;
   
    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._commonService.common(p,this.operation,this.application).subscribe(
        data => {

          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.response = this._global.getVal(data, 'response', '');
            this.latitude=this._global.getVal(this.response,'addressJson.latitude','');
            this.map_url= this.map_url + this._global.getVal(this.response,'addressJson.city','')+","+this._global.getVal(this.response,'addressJson.state','')+","+this._global.getVal(this.response,'addressJson.country','') +","+this._global.getVal(this.response,'addressJson.zip','')+'&zoom=17&key='+this._global.GOOGLE_API;
            if(this._global.getVal(this.response, 'tag', '')){
              this.tag=this._global.getVal(this.response, 'tag', '').split(",");
            }
            if(this._global.getVal(this.response, 'category', '')){
              this.category=this._global.getVal(this.response, 'category', '').split("|");
            }
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
            this.images.push(this._commonPipe.transform(this.response, ['image', this.application, 'id', 'name', 'l']));
            this._global.addMetaInfo(this.response, 'view','name');
            this.rate = this._global.getVal(this.response, 'rating', '');
            if (this.response['hours']) {
              if (this.response['hours'][0]) {
                Object.entries(this.response['hours'][0]['open']).forEach(([key, value]) => {
                  const hour = this.fb.group({
                    day: [value['day']],
                    start: [value['start']],
                    end: [value['end']],
                    day_txt: [this.getDay(value['day'])],
                    start_txt: [this.getSHour(value['start'])],
                    end_txt: [this.getEHour(value['end'])]
                  });
                  (this.appEditForm.get('hours') as FormArray).push(hour);

                });
              }
            }
            this.report_param = {
              id: this.response.id,
              name: this.response.name
            };
          }else{
            this.router.navigate(['']);
          }



        },
        error => {
          console.log("error", JSON.stringify(error));
        });
   // });
  }
  ngOnInit() {

  }

  getDay(d) {
    const day = this.weekday.find(x => x.value == d);
    return day['label'];
  }
  getSHour(h) {
    const start = this.hours_start.find(x => x.value == h);
    return this._global.getVal(start, 'label', '');
  }
  getEHour(h) {
    const end = this.hours_end.find(x => x.value == h);
    return this._global.getVal(end, 'label', '');
  }

  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  edit() {
    this.router.navigate(['/edit/' + this.application], { queryParams: { 'id': this.id } });
  }
}
